import { env } from '@/config/env';
import satisfactionShield from '@/features/payments/assets/satisfaction-shield.webp';
import laurelIcon from '@/features/payments/assets/icon-laurel.svg';
import ratingStars from '@/features/payments/assets/icon-rating-stars.svg';

export function OfferSatisfaction() {
  return (
    <section className="flex flex-col items-center gap-6">
      <div className="flex w-full flex-col items-center gap-4">
        <img
          src={satisfactionShield}
          alt=""
          className="h-[98px] w-20 object-contain"
        />
        <h3 className="text-center font-display text-xl font-bold leading-6 text-mf-neutral-900">
          Satisfaction Guaranteed
        </h3>
        <p className="whitespace-pre-wrap text-center font-body text-sm font-normal leading-4 text-mf-neutral-600">
          {`We know finding money you're owed should feel simple, not stressful. That's why we've built a process that's fast, transparent, and actually works — no confusing forms, no hidden fees.\n\nBut if for any reason your experience doesn't feel effortless, we've got your back.`}
        </p>
      </div>

      <div className="flex w-full flex-col gap-3 rounded-[24px] bg-white px-4 pb-4 pt-3 shadow-[0_0_8px_rgba(26,22,19,0.03)]">
        <div className="flex items-center gap-2">
          <span className="relative h-20 w-[34px] shrink-0 overflow-hidden">
            <img src={laurelIcon} alt="" className="size-full" />
          </span>
          <div className="flex min-w-0 flex-1 flex-col items-center gap-0.5 text-center">
            <p className="w-full font-display text-[28px] font-bold leading-9 text-mf-neutral-900">
              2,850,000+
            </p>
            <p className="w-full font-body text-sm font-normal leading-4 text-mf-neutral-600">
              people already using {env.VITE_APP_NAME} to find money
            </p>
          </div>
          <span className="relative h-20 w-[34px] shrink-0 overflow-hidden">
            <img src={laurelIcon} alt="" className="-scale-x-100 size-full" />
          </span>
        </div>
        <div className="flex items-center gap-4 rounded-lg bg-mf-green/10 px-4 py-3">
          <div className="flex min-w-0 flex-1 flex-col">
            <p className="font-body text-base font-bold leading-5 text-mf-neutral-900">
              <span className="text-mf-green">4.9</span> out of 5
            </p>
            <p className="font-body text-xs font-normal leading-4 text-mf-neutral-600">Based on verified responses</p>
          </div>
          <span className="relative h-5 w-[108px] shrink-0 overflow-hidden">
            <img src={ratingStars} alt="" className="size-full" />
          </span>
        </div>
      </div>
    </section>
  );
}
